import { Component, OnInit } from '@angular/core';
import { GtmService } from '@df/module-gtm/gtm.service';
import { ICmsOutletBlockComponent } from '../block/icms-outlet-block.component';
@Component({
    selector: 'error-404',
    templateUrl: 'error-404.html',
    standalone: true,
    imports: [ICmsOutletBlockComponent],
})
export class Error404Component implements OnInit {
    constructor(private gtmService: GtmService) {

    }
    ngOnInit() {
        this.gtmService.sendEventGA4('error_tracking', { error_type: 'page', error_message: 'This page cannot be found' });
    }
}
